<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="状态">
        <el-select v-model="status" placeholder="状态" clearable>
          <el-option label="拼班中" :value="0"></el-option>
          <el-option label="拼班成功" :value="1"></el-option>
          <el-option label="拼班失败" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
        <el-table-column type="expand">
      <template slot-scope="{row}">
       <div>
        <div v-for="(user,i) in row.map.users" :key="i">
          <div>{{user.nick_name}}</div>
        </div>
        
       </div>
      </template>
    </el-table-column>

      <template #count="{ row }">
        <div>
          <p>
            已拼{{ row.map.users ? row.map.users.length : 0 }}/{{
              row.max_count
            }}人
          </p>
        </div>
      </template>
      <template #status="{ row }">
        <div>
          <el-tag type="info" size="small" v-if="row.status === 0"
            >拼班中</el-tag
          >
          <el-tag type="success" size="small" v-if="row.status === 1"
            >拼班成功</el-tag
          >
          <el-tag type="info" size="small" v-if="row.status === 2"
            >拼班失败</el-tag
          >
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button
            v-if="row.status == 0"
            type="success"
            size="small"
            @click="updateStatus(row, 1)"
            >拼班成功</el-button
          >
          <el-button
            v-if="row.status == 0"
            type="warning"
            size="small"
            @click="updateStatus(row, 2)"
            >拼班失败</el-button
          >
          <!-- <el-button  type="danger" size="small" @click="del(row)"
            >删除</el-button
          > -->
        </div>
      </template>
    </auto-table>

  </div>
</template>

<script>

export default {

  data() {
    return {
      DataList: [],
      Option: [
        { name: "名称", value: "name" },
        { name: "拼班人数", value: "count", type: "custom" },
        { name: "状态", value: "status", type: "custom" },
        { name: "开始时间", value: "create_time" },
        { name: "截至时间", value: "end_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 0,
      infoShow:false,
      cur:{},
      course:{},
      stu:[],
      defaultPic:'https://img.curiousmore.com/1723426945107.png'
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    openInfo(row){
        this.cur = row
        this.stu = row.map.users
        this.course = row.map.course || row.map.need
        this.infoShow = true
    },
    addGroup() {
      this.$refs.create.open();
    },
    updateInfo(row) {
      this.$router.push({ name: "addActivity", query: { aid: row.id } });
    },
    del(row) {
      this.$confirm("确定删除").then(() => {
        this.$post("/user/businessActivityType/update", {
          id: row.id,
          status: 3,
        }).then((res) => {
          this.getList(1);
        });
      });
    },
    updateStatus(row, status) {
        let t = '确认拼班成功，成功后学员可支付尾款。'
        if(status == 2){
            t = '确认拼班失败，同意后将退回学员的定金'
        }

      this.$confirm(t).then(() => {
        const loading = this.$loading({
          lock: true,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.$post("/user/activityGrouping/updateStatus", {
          id: row.id,
          status,
        }).then((res) => {
            loading.close()
          this.getList(1);
        }).catch(err=>{
            loading.close()
        })
      });
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/activityGrouping/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          status: this.status,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.avas{
  display: flex;
  flex-wrap: wrap;

}
.ava{
    width: 40px;
    height: 40px;
    margin-right: 10px;
    margin-bottom: 10px;
}
</style>